import { Component, OnInit } from '@angular/core';
import { Settings } from 'src/app/services/settings';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-survey-emails',
  templateUrl: './survey-emails.component.html',
  styleUrls: ['./survey-emails.component.css']
})
export class SurveyEmailsComponent implements OnInit {

    public enabledList:any;
    public selectedValue: string;
    public settingsRecord: any;
    public currentRunState: string;
    public visibleModify: boolean = false;
    constructor(public settingsService: UserService) {
        this.enabledList = [];
        this.enabledList.push({id: 'true', description: 'Enabled'});
        this.enabledList.push({id: 'false', description: 'Disabled'});

    }

    ngOnInit() {
        if(Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_SURVEY_EMAILS', "WRITE")) {
           this.visibleModify = true;
        }
       this.settingsRecord = Settings.getInstance().getGeneralSettingByKey('surveyemailservice');
       this.selectedValue = this.settingsRecord.value;
       this.currentRunState = this.displayCurrentState(this.selectedValue);
    }

    public updateSurveyEmailStatus(val: any):void {

        this.settingsRecord.value = val;
        this.settingsService.createUpdateSetting(this.settingsRecord).subscribe(
            (result) => {
                this.currentRunState = this.displayCurrentState(this.selectedValue);
            },
            (error) => {
                Settings.getInstance().handleError(error, 'Updating survey email service setting');
            });
    }
    public displayCurrentState(runningState: string): string {

        if(runningState === "true") {
            return 'Running ...';
        }

        return 'Suspended ... ';
    }
}
